import * as React from 'react';
import {
  useContractWrite,
  useWaitForTransaction,
  usePrepareContractWrite,
  useAccount,
} from 'wagmi';
import { ConnectButton } from '@rainbow-me/rainbowkit';

export function MintWrite(props) {
  const { address, isConnected } = useAccount();
  const [error, setError] = React.useState(null);
  const { config, isError, isLoading } = usePrepareContractWrite({
    address: props.config.address,
    abi: props.config.abi,
    functionName: props.config.functionName,
    args: props.config.args,
    value: props.config.value,
    overrides: props.config.overrides,
    onError: (error) => {
      setError(error);
    },
  });
  const { write } = useContractWrite({ ...config, onSuccess: props.resetCart });
  useWaitForTransaction(write);

  function openWallet() {
    if (window.ethereum) {
      window.ethereum
        .enable()
        .then((accounts) => {
          // Metamask is enabled and user has allowed access to their accounts
          const account = accounts[0];
          window.open(`https://etherscan.io/address/${account}`, '_blank');
        })
        .catch((error) => {
          // User has denied access to their accounts or Metamask is not installed
          console.error(error);
        });
    } else {
      // Metamask is not installed
      window.open('https://metamask.io/', '_blank');
    }
  }

  function handleMint() {
    if (isError) {
      // Trigger wallet interaction even if there's an error
      write?.();
      // Handle error here (e.g., show a custom error message or alert)
      alert('Error: ' + error?.message || 'An error occurred.');
    } else {
      write?.();
    }
  }
  React.useEffect(() => {
    if (write?.confirmed) {
      window.location.reload();
    }
  }, [write?.confirmed]);
  return (
    <>
      {isConnected ? (
        <>
          {isLoading && <div>Loading...</div>}
          {isError ? (
            <button className='btn btn-primary' disabled={!props.cart.length}>
              <div>
                <p>Insufficient funds to complete your transaction</p>
                <p style={{ display: 'block' }}>Please verify your wallet 😀</p>
              </div>
            </button>
          ) : (
            <button
              className='btn btn-primary'
              onClick={handleMint}
              disabled={!props.cart.length}
            >
              {`Cart Total: ${props.eth} ETH || Click Here to continue`}
            </button>
          )}
          {write?.error && <div>Error: {write.error.message}</div>}
          {write?.transactionHash && (
            <div>Transaction Hash: {write.transactionHash}</div>
          )}
          {write?.confirmed && <div>Transaction Confirmed!</div>}
        </>
      ) : (
        <div className='flex justify-center '>
          <ConnectButton
            label={`Cart Total: ${props.eth} ETH || Connect Wallet to continue`}
          />
        </div>
      )}
    </>
  );
}
